<template>
    <div class="select_button d-flex">
        <div :class="{ 'active': button_active, 'btm_box': true}">{{button_name}}</div>
    </div>
</template>
<script>
export default {
    props:[
        "button_active",
        "button_name",
    ],
    
}
</script>

<style>
.select_button{
    justify-content: center;
    align-items: center;
}
.select_button .btm_box{
    width: 150px;
    text-align: center;
    border: 2px solid #00a0e9;
    height: 40px;
    line-height: 36px;
    color:#00a0e9;
    font-weight: 700;
    font-size: 21px;
    cursor: pointer;
}
/* .select_button{
    margin-right: 20px;
} */
.select_button .active{
    background: #00a0e9;
    color:white;
}
</style>